import { styled } from "styled-components";

export const Wrapper = styled.div`
  padding-top: ${({ theme }) => theme.spacing[4]};
`;

export const TableWrapper = styled.div``;
